/**
 * Per-page-load session id. Stable across the lifetime of this page view,
 * used to dedupe beacon + verify into a single audit row.
 *
 * Prefer the id created by the inline <head> beacon (window.__TC_SID) so the
 * pageView and verify rows merge into one audit. Fall back to generating one
 * for SSR or if the inline script failed.
 */
function makeId(): string {
  const arr = new Uint8Array(16);
  crypto.getRandomValues(arr);
  return Array.from(arr)
    .map((b) => b.toString(16).padStart(2, '0'))
    .join('');
}

declare global {
  interface Window {
    __TC_SID?: string;
    __TC_PAGE_VIEW_SENT?: boolean;
  }
}

export const sessionId = typeof window !== 'undefined' ? (window.__TC_SID ?? makeId()) : 'ssr';
